import { render } from "./RoomCategoryIndex.vue?vue&type=template&id=c7735668"
import script from "./RoomCategoryIndex.vue?vue&type=script&lang=js"
export * from "./RoomCategoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__